module.exports = __webpack_public_path__ + "img/31_ancillary.e1554abf.jpg";